module.exports = __webpack_public_path__ + "static/fcra-2017-18-q4-20de3d9951a76aea417ec34d656f94ee.pdf";